import { render } from "./ExTableZeroField.vue?vue&type=template&id=bb2a2c48"
import script from "./ExTableZeroField.vue?vue&type=script&lang=js"
export * from "./ExTableZeroField.vue?vue&type=script&lang=js"

import "./ExTableZeroField.vue?vue&type=style&index=0&id=bb2a2c48&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__